export default __webpack_public_path__ + "static/media/Liberty Bankers.6b11b999.svg";